import React, { useState } from 'react'
import PropTypes from 'prop-types'

const PasswordReveal = ({ url, copyUrl, permitted, dataFetcher }) => {
  const [passwords, setPasswords] = useState()
  const [copiedIndex, setCopiedIndex] = useState(null)

  const isRevealed = () => {
    return !!passwords
  }

  const handleCopyOne = (e, password, index) => {
    e.preventDefault()
    navigator.clipboard.writeText(password).then(() => {
      setCopiedIndex(index)
      setTimeout(() => setCopiedIndex(null), 2000)

      if (copyUrl) {
        $.post({
          url: copyUrl
        })
      }
    })
  }

  const content = () => {
    if (permitted && isRevealed()) {
      if (passwords.length === 0 || typeof(passwords) != 'object') {
        return '-'
      } else {
        return(
          <ul className="list-unstyled password-list">
            { passwords.map((password, index) => {
              return (
                <li key={ index }>
                  <code className="password-value">{ password }</code>
                  <a onClick={ (e) => handleCopyOne(e, password, index) }
                     href=""
                     className="copy-password-link"
                     title={ copiedIndex === index ? 'Copied!' : 'Copy to clipboard' }>
                    <span className={ `glyphicon ${copiedIndex === index ? 'glyphicon-ok' : 'glyphicon-copy'}` }/>
                  </a>
                </li>
              )
            }) }
          </ul>
        )
      }
    } else {
      return '••••••••••••'
    }
  }

  const handleClick = (e) => {
    e.preventDefault()

    if (!isRevealed()) {
      if (dataFetcher) {
        dataFetcher().then((data) => {
          setPasswords(data)
        })
      } else {
        $.getJSON({ url: url }).then((data) => setPasswords(data))
      }
    } else {
      setPasswords(null)
      setCopiedIndex(null)
    }
  }

  const linkText = () => {
    return isRevealed() ? 'hide' : 'reveal'
  }

  const revealLink = () => {
    if (permitted) {
      return (<a onClick={ handleClick } href="">{ linkText() }</a>)
    }
  }

  return (
    <React.Fragment>
      <span className="password-reveal-content">{ content() }</span>
      { revealLink() }
    </React.Fragment>
  )
}

PasswordReveal.propTypes = {
  url: PropTypes.string, // for use with the default data fetcher
  copyUrl: PropTypes.string, // URL to POST when password is copied (for audit logging)
  permitted: PropTypes.bool,
  dataFetcher: PropTypes.func
}

export default PasswordReveal